import * as o from "react";
import m from "../lib/IconBase.es.js";
import t from "../defs/TelegramLogo.es.js";
const e = o.forwardRef((r, a) => /* @__PURE__ */ o.createElement(m, { ref: a, ...r, weights: t }));
e.displayName = "TelegramLogoIcon";
const s = e;
export {
  s as TelegramLogo,
  e as TelegramLogoIcon
};
